import {
  LIVE_ROUTE,
  SEARCH_ROUTE,
  DOORS_ROUTE,
  SENSORS_ROUTE,
  INTRUSION_ROUTE,
  PLACES_ROUTE,
  PEOPLE_ROUTE,
  GROUPS_ROUTE,
  PERMISSIONS_ROUTE,
  CAMERAS_ROUTE,
  ROLES_ROUTE,
  VIEWS_ROUTE,
  SAVED_CLIPS_ROUTE,
  SCHEDULES_ROUTE,
  GATEWAYS_ROUTE,
  HOLIDAY_SETS_ROUTE,
  SETTINGS_ROUTE,
  // HELP_ROUTE,
  // INTEGRATIONS_ROUTE
} from '@/config/routes';
import { REPORTS_ROUTE } from './routes/reports';
import { AUDIT_ROUTE } from './routes/audit';
import { AI_ROUTE } from './routes/ai';
import { RULES_ROUTE } from './routes/rules';
import { DEVICES_ROUTE } from './routes/devices';
import type { NavigationItem } from "@/types"
import { TIMELINE_ROUTE } from '@/config/routes/timeline';

export const APP_NAVIGATION_PRIMARY: NavigationItem[] = [
  {
    heading: AI_ROUTE.UI_LABEL,
    icon: AI_ROUTE.UI_ICON,
    routeName: AI_ROUTE.ROUTE_NAME,
    privileges: AI_ROUTE.PRIVILEGES,
    isBeta: true,
  },
  {
    heading: LIVE_ROUTE.UI_LABEL,
    icon: LIVE_ROUTE.UI_ICON,
    routeName: LIVE_ROUTE.ROUTE_NAME,
    privileges: LIVE_ROUTE.PRIVILEGES,
  },
  {
    heading: TIMELINE_ROUTE.UI_LABEL,
    icon: TIMELINE_ROUTE.UI_ICON,
    routeName: TIMELINE_ROUTE.ROUTE_NAME,
    privileges: TIMELINE_ROUTE.PRIVILEGES,
  },
  {
    heading: SEARCH_ROUTE.UI_LABEL,
    icon: SEARCH_ROUTE.UI_ICON,
    routeName: SEARCH_ROUTE.ROUTE_NAME,
    privileges: SEARCH_ROUTE.PRIVILEGES,
  },
  {
    heading: PLACES_ROUTE.UI_LABEL,
    icon: PLACES_ROUTE.UI_ICON,
    routeName: PLACES_ROUTE.ROUTE_NAME,
    privileges: PLACES_ROUTE.PRIVILEGES,
  },
]

export const APP_NAVIGATION_SECONDARY: NavigationItem[] = [
  {
    heading: SAVED_CLIPS_ROUTE.UI_LABEL,
    icon: SAVED_CLIPS_ROUTE.UI_ICON,
    routeName: SAVED_CLIPS_ROUTE.ROUTE_NAME,
    privileges: SAVED_CLIPS_ROUTE.PRIVILEGES,
  },
  {
    heading: REPORTS_ROUTE.UI_LABEL,
    icon: REPORTS_ROUTE.UI_ICON,
    routeName: REPORTS_ROUTE.ROUTE_NAME,
    privileges: REPORTS_ROUTE.PRIVILEGES,
  },
  {
    heading: 'Configuration',
    icon: ['fal', 'gear'],
    privileges: [...new Set([
      // DEV NOTE :: this ensure that the Configuration button only renders if the user has at least one of the privileges within it
      PEOPLE_ROUTE.PRIVILEGES,
      GROUPS_ROUTE.PRIVILEGES,
      PERMISSIONS_ROUTE.PRIVILEGES,
      ROLES_ROUTE.PRIVILEGES,
      GATEWAYS_ROUTE.PRIVILEGES,
      DEVICES_ROUTE.PRIVILEGES,
      CAMERAS_ROUTE.PRIVILEGES,
      DOORS_ROUTE.PRIVILEGES,
      INTRUSION_ROUTE.PRIVILEGES,
      SCHEDULES_ROUTE.PRIVILEGES,
      HOLIDAY_SETS_ROUTE.PRIVILEGES,
      RULES_ROUTE.PRIVILEGES,
      VIEWS_ROUTE.PRIVILEGES,
    ].flat())],
    routeName: '',
    groups: [
      {
        key: 'people',
        children: [
          {
            heading: PEOPLE_ROUTE.UI_LABEL,
            icon: PEOPLE_ROUTE.UI_ICON,
            routeName: PEOPLE_ROUTE.ROUTE_NAME,
            privileges: PEOPLE_ROUTE.PRIVILEGES,
          },
          {
            heading: GROUPS_ROUTE.UI_LABEL,
            icon: GROUPS_ROUTE.UI_ICON,
            routeName: GROUPS_ROUTE.ROUTE_NAME,
            privileges: GROUPS_ROUTE.PRIVILEGES,
          },
          {
            heading: PERMISSIONS_ROUTE.UI_LABEL,
            icon: PERMISSIONS_ROUTE.UI_ICON,
            routeName: PERMISSIONS_ROUTE.ROUTE_NAME,
            privileges: PERMISSIONS_ROUTE.PRIVILEGES,
          },
          {
            heading: ROLES_ROUTE.UI_LABEL,
            icon: ROLES_ROUTE.UI_ICON,
            routeName: ROLES_ROUTE.ROUTE_NAME,
            privileges: ROLES_ROUTE.PRIVILEGES,
          },
        ]
      },
      {
        key: 'devices',
        children: [
          {
            heading: GATEWAYS_ROUTE.UI_LABEL,
            icon: GATEWAYS_ROUTE.UI_ICON,
            routeName: GATEWAYS_ROUTE.ROUTE_NAME,
            privileges: GATEWAYS_ROUTE.PRIVILEGES,
          },
          {
            heading: DEVICES_ROUTE.UI_LABEL,
            icon: DEVICES_ROUTE.UI_ICON,
            routeName: DEVICES_ROUTE.ROUTE_NAME,
            privileges: DEVICES_ROUTE.PRIVILEGES,
          },
          {
            heading: CAMERAS_ROUTE.UI_LABEL,
            icon: CAMERAS_ROUTE.UI_ICON,
            routeName: CAMERAS_ROUTE.ROUTE_NAME,
            privileges: CAMERAS_ROUTE.PRIVILEGES,
          },
          {
            heading: DOORS_ROUTE.UI_LABEL,
            icon: DOORS_ROUTE.UI_ICON,
            routeName: DOORS_ROUTE.ROUTE_NAME,
            privileges: DOORS_ROUTE.PRIVILEGES,
          },
          {
            heading: SENSORS_ROUTE.UI_LABEL,
            icon: SENSORS_ROUTE.UI_ICON,
            routeName: SENSORS_ROUTE.ROUTE_NAME,
            privileges: SENSORS_ROUTE.PRIVILEGES,
          },
          {
            heading: INTRUSION_ROUTE.UI_LABEL,
            icon: INTRUSION_ROUTE.UI_ICON,
            routeName: INTRUSION_ROUTE.ROUTE_NAME,
            privileges: INTRUSION_ROUTE.PRIVILEGES,
          },
        ]
      },
      {
        key: 'other',
        children: [
          {
            heading: SCHEDULES_ROUTE.UI_LABEL,
            icon: SCHEDULES_ROUTE.UI_ICON,
            routeName: SCHEDULES_ROUTE.ROUTE_NAME,
            privileges: SCHEDULES_ROUTE.PRIVILEGES,
          },
          {
            heading: HOLIDAY_SETS_ROUTE.UI_LABEL,
            icon: HOLIDAY_SETS_ROUTE.UI_ICON,
            routeName: HOLIDAY_SETS_ROUTE.ROUTE_NAME,
            privileges: HOLIDAY_SETS_ROUTE.PRIVILEGES,
          },
          {
            heading: RULES_ROUTE.UI_LABEL,
            icon: RULES_ROUTE.UI_ICON,
            routeName: RULES_ROUTE.ROUTE_NAME,
            privileges: RULES_ROUTE.PRIVILEGES,
          },
          {
            heading: VIEWS_ROUTE.UI_LABEL,
            icon: VIEWS_ROUTE.UI_ICON,
            routeName: VIEWS_ROUTE.ROUTE_NAME,
            privileges: VIEWS_ROUTE.PRIVILEGES,
          },
        ]
      },
      {
        key: 'admin',
        children: [
          {
            heading: AUDIT_ROUTE.UI_LABEL,
            icon: AUDIT_ROUTE.UI_ICON,
            routeName: AUDIT_ROUTE.ROUTE_NAME,
            privileges: AUDIT_ROUTE.PRIVILEGES,
          },
        ]
      }
    ],
  },
]

export const APP_NAVIGATION_TERTIARY: NavigationItem[] = [
  // {
  //   heading: HELP_ROUTE.UI_LABEL,
  //   routeName: HELP_ROUTE.ROUTE_NAME,
  //   icon: HELP_ROUTE.UI_ICON,
  //   privileges: HELP_ROUTE.PRIVILEGES,
  // },
  // {
  //   heading: INTEGRATIONS_ROUTE.UI_LABEL,
  //   routeName: INTEGRATIONS_ROUTE.ROUTE_NAME,
  //   icon: INTEGRATIONS_ROUTE.UI_ICON,
  //   privileges: INTEGRATIONS_ROUTE.PRIVILEGES,
  // },
]

export const APP_NAVIGATION_SETTINGS: NavigationItem = {
  heading: SETTINGS_ROUTE.UI_LABEL,
  routeName: SETTINGS_ROUTE.ROUTE_NAME,
  icon: SETTINGS_ROUTE.UI_ICON,
  privileges: SETTINGS_ROUTE.PRIVILEGES,
}
